export * from './auth';
export * from './auth.module';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/angularfire2/auth/public_api.js
// module id = ../../../../angularfire2/auth/public_api.js
// module chunks = 4